import { render, staticRenderFns } from "./ExperienceCard.vue?vue&type=template&id=2c378054&scoped=true&"
import script from "./ExperienceCard.vue?vue&type=script&lang=js&"
export * from "./ExperienceCard.vue?vue&type=script&lang=js&"
import style0 from "./ExperienceCard.vue?vue&type=style&index=0&id=2c378054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c378054",
  null
  
)

export default component.exports